import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, Check } from 'react-feather';

const CHIPS = [
    { id: 'today', label: 'Today' },
    { id: 'yesterday', label: 'Yesterday' },
    { id: '7d', label: 'Last 7d' },
    { id: '30d', label: 'Last 30d' },
    { id: 'mtd', label: 'MTD' },
    { id: 'custom', label: 'Custom' }
];

const DateRangePresets = ({ preset, startDate, endDate, onPreset, onCustom }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [localStart, setLocalStart] = useState(startDate || '');
    const [localEnd, setLocalEnd] = useState(endDate || '');
    const popoverRef = useRef(null);
    const today = new Date().toISOString().split('T')[0];

    useEffect(() => {
        if (open) {
            setLocalStart(startDate || '');
            setLocalEnd(endDate || '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const handleChip = (id) => {
        if (id === 'custom') {
            setLocalStart(startDate || today);
            setLocalEnd(endDate || today);
            setOpen(true);
            onPreset('custom');
        } else {
            setOpen(false);
            onPreset(id);
        }
    };

    const commit = () => {
        if (localStart && localEnd) {
            onCustom(localStart, localEnd);
        }
        setOpen(false);
    };

    return (
        <div className="dg-presets">
            {CHIPS.map(c => (
                <button
                    key={c.id}
                    type="button"
                    className={`dg-chip${preset === c.id ? ' active' : ''}`}
                    onClick={() => handleChip(c.id)}
                >
                    {c.id === 'custom' && <Calendar size={13} />}
                    {t(c.label)}
                </button>
            ))}
            {preset === 'custom' && (
                <div className="dg-custom-range" ref={popoverRef}>
                    <span className="dg-range-display" onClick={() => setOpen(o => !o)}>
                        {startDate || '—'} → {endDate || '—'}
                    </span>
                    {open && (
                        <div className="dg-popover">
                            <label>
                                <span>{t('Start')}</span>
                                <input
                                    type="date"
                                    defaultValue={localStart}
                                    max={today}
                                    onChange={e => setLocalStart(e.target.value)}
                                />
                            </label>
                            <label>
                                <span>{t('End')}</span>
                                <input
                                    type="date"
                                    defaultValue={localEnd}
                                    max={today}
                                    onChange={e => setLocalEnd(e.target.value)}
                                />
                            </label>
                            <button type="button" className="dg-popover-close" onClick={commit}>
                                <Check size={12} />
                                {t('Apply')}
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default DateRangePresets;
